import { TOAST_TYPE } from "../../constants";
import { CUSTOMER_HOME_ROUTES } from "../../constants/customerApiRoutes";
import { getCookie, showToastMessage } from "../../utils";
import API from "../axios";

export const getHomesForYou = async (
  handleData: CallableFunction,
  handleLoading: CallableFunction,
  city_id: string = "",
  lat: string = "",
  long: string = ""
) => {
  try {
    const data = getCookie("coordinates");
    const response = await API.get(
      `${CUSTOMER_HOME_ROUTES.HOMES_FOR_YOU}?city_id=${city_id}&lat=${lat || data?.latitude || ""}&long=${long || data?.longitude || ""}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getFeaturedProperty = async (
  handleData: CallableFunction,
  handleLoading: CallableFunction,
  lat: string = "",
  long: string = ""
) => {
  try {
    const data = getCookie("coordinates");
    const response = await API.get(
      `${CUSTOMER_HOME_ROUTES.FEATURED_PROPERTY}?lat=${lat || data?.latitude || ""}&long=${long || data?.longitude || ""}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getFeaturedProject = async (
  handleData: CallableFunction,
  handleLoading: CallableFunction,
  lat: string = "",
  long: string = ""
) => {
  try {
    const data = getCookie("coordinates");
    const response = await API.get(
      `${CUSTOMER_HOME_ROUTES.FEATURED_PROJECT}?lat=${lat || data?.latitude || ""}&long=${long || data?.longitude || ""}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getLatestProject = async (
  handleData: CallableFunction,
  handleLoading: CallableFunction,
  lat: string = "",
  long: string = ""
) => {
  try {
    const data = getCookie("coordinates");
    const response = await API.get(
      `${CUSTOMER_HOME_ROUTES.LATEST_PROJECT}?lat=${lat || data?.latitude || ""}&long=${long || data?.longitude || ""}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getProjects = async (
  handleData: CallableFunction,
  handleLoading: CallableFunction
) => {
  try {
    const response = await API.get(
      `${CUSTOMER_HOME_ROUTES.GET_PROJECTS}?page=1&limit=10`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const createSubscribeMail = async (
  data: any,
  handleLoading: CallableFunction
) => {
  try {
    const response = await API.post(
      `${CUSTOMER_HOME_ROUTES.NEWS_LETTER_SUBSCRIBE}`,
      data
    );
    showToastMessage(TOAST_TYPE.SUCCESS, response.data.message);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};

export const getSimilarProjects = async (
  handleData: CallableFunction,
  handleLoading: CallableFunction,
  filteration: any = {
    page: 1,
    limit: 10,
    category_id: "",
  }
) => {
  try {
    const response = await API.post(
      `${CUSTOMER_HOME_ROUTES.HOME_SEARCH}?type=2&page=${filteration?.page}&limit=${filteration?.limit}&category_id=${filteration?.category_id ?? ""}`
    );
    handleData(response?.data?.data);
  } catch (error: any) {
    showToastMessage(
      TOAST_TYPE.ERROR,
      error?.response?.data?.message ?? error?.message
    );
  } finally {
    handleLoading(false);
  }
};
